import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()
    return {
        headerLeft: {
            display: 'flex',
            width: 'fit-content',
            alignItems: 'center',
            '& .MuiIconButton-root': {
                color: colors.color4,
                fontWeight: '600',
                marginLeft: '-10px',
            },
            '& .MuiTypography-root': {
                fontSize: '17px',
                fontWeight: '400',
                color: colors.color4,
            }
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '20px',
            minHeight: '40px'
        },
        hide: {
            visibility: 'hidden',
        },
        flex: {
            display: 'flex',
            alignItems: 'center',
            '&.flex-j-e': {
                justifyContent: 'end',
            },
        },
        section: {
            marginBottom: '32px',
        },
        clean: {
            fontSize: '2.4rem',
            color: colors.color4,
            padding: '6px',
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
        },
        title: {
            flexGrow: 1,
            fontSize: '22px',
            fontWeight: '500',
        },
        paper: {
            padding: 2,
            height: '100%',
            display: 'flex',
            gap: 1,
            flexDirection: 'column',
        },
        grid: {
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        containerTable: {
            '& .MuiPaper-root': {
                maxHeight: '400px',
                width: '100%'
            }
        },
        select: {
            color: colors.color16,
            fontWeight: '500',
            fontSize: '14px',
            padding: '0px 4px',
            cursor: 'pointer',
        },
        all: {
            display: 'flex',
            alignItems: 'center',
            '& .remove-m': {
                margin: '0px'
            },
            gap: 1.5
        },
        containerTitleAndButtons:{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 2,
            flexWrap: 'wrap'
        },
        containerButtons: {
            display:'flex',
            alignItems: 'center',
            gap: 1,
            //flexWrap: 'wrap'
        },
        buttonNext :{
            '&.MuiButtonBase-root':{
                padding: '7px 16px'
            }
        }
    }
}

export { useStyles }
